import { render } from "./LandingIndex.vue?vue&type=template&id=6b7618da"
import script from "./LandingIndex.vue?vue&type=script&lang=js"
export * from "./LandingIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__